import { createSlice } from "@reduxjs/toolkit";
import { mapCdrList } from "../../Pages/FSA/utils";

export const name = "fsa";

export const fsaSlice = createSlice({
  name,
  initialState: {
    cdrListLoading: false,
    cdrList: [],
    cdrListPageCount: 0,
    cdrListError: null,
    fsaDailyCount: 0,
    fsaTotalCount: 0,
    fsaAnalysisStatistics: {
      cleanAnalysisPct: 0,
      suspiciousAnalysisPct: 0,
      maliciousAnalysisPct: 0,
    },
    addAppLoading: false,
    apps: [],
    appsLoading: false,
    editAppId: "",
    editAppLoading: false,
    deleteAppId: "",
    deleteAppLoading: false,
  },
  reducers: {
    RequestCdrList: (state) => {
      state.cdrListLoading = true;
      state.cdrListError = false;
    },
    SuccessCdrList: (state, action) => {
      const { list, page_count } = action.payload;
      state.cdrList = mapCdrList(list);
      state.cdrListPageCount = page_count;
      state.cdrListLoading = false;
      state.cdrListError = false;
    },
    FailureCdrList: (state) => {
      state.cdrListPageCount = 0;
      state.cdrListLoading = false;
      state.cdrListError = true;
    },
    RequestFsaCount: () => {},
    SuccessFsaCount: (state, action) => {
      const { type, count } = action.payload;
      if (type === "daily") {
        state.fsaDailyCount = count;
      } else if (type === "total") {
        state.fsaTotalCount = count;
      }
    },
    FailureFsaCount: (state, action) => {
      const type = action.payload.type;
      if (type === "daily") {
        state.fsaDailyCount = 0;
      } else if (type === "total") {
        state.fsaTotalCount = 0;
      }
    },
    RequestFsaAnalysisStatistics: () => {},
    SuccessFsaAnalysisStatistics: (state, action) => {
      state.fsaAnalysisStatistics = action.payload;
    },
    FailureFsaAnalysisStatistics: (state) => {
      state.fsaAnalysisStatistics = {
        cleanAnalysisPct: 0,
        suspiciousAnalysisPct: 0,
        maliciousAnalysisPct: 0,
      };
    },
    RequestAddApplication: (state) => {
      state.addApplicationLoading = true;
    },
    SuccessAddApplication: (state) => {
      state.addApplicationLoading = false;
    },
    FailureAddApplication: (state) => {
      state.addApplicationLoading = false;
    },
    RequestFsaApplications: (state) => {
      state.appsLoading = true;
    },
    SuccessFsaApplications: (state, action) => {
      state.apps = action.payload;
      state.appsLoading = false;
    },
    FailureFsaApplications: (state) => {
      state.appsLoading = false;
    },
    RequestEditApplication: (state, action) => {
      state.editAppId = action.payload.appId;
      state.editAppLoading = true;
    },
    SuccessEditApplication: (state) => {
      state.editAppLoading = false;
    },
    FailureEditApplication: (state) => {
      state.editAppLoading = false;
    },
    RequestDeleteApplication: (state, action) => {
      state.deleteAppId = action.payload;
      state.deleteAppLoading = true;
    },
    SuccessDeleteApplication: (state) => {
      state.deleteAppLoading = false;
    },
    FailureDeleteApplication: (state) => {
      state.deleteAppLoading = false;
    },
  },
});

export default fsaSlice;
